module.exports = __webpack_public_path__ + "static/media/bg.7ca2d087.png";